<template>
  <v-container fluid>
    <v-col cols="12">
      <v-card>
        <v-card-title class="headline">
          契約管理
        </v-card-title>
        <v-divider class="mx-3"></v-divider>
        <v-card-text>
          <v-row no-gutters class="pl-5 mb-10">
            <v-col cols="11">
              <div class="d-flex flex-row align-baseline">
                <label class="mr-3">企業コード：</label>
                <v-text-field
                    v-model="searchCompanyCode"
                    dense
                    outlined
                    size="30"
                    name="company_code"
                    required
                    placeholder="U-XXXX-XXXX"
                    v-bind:error-messages="errors.company_code"
                ></v-text-field>
              </div>

              <div class="d-flex flex-row align-baseline">
                <label class="mr-3">店舗コード：</label>
                <v-text-field
                    v-model="searchStoreCode"
                    dense
                    outlined
                    size="30"
                    name="store_code"
                    placeholder="XXXX"
                ></v-text-field>
              </div>

              <div class="d-flex flex-row justify-center">
                <v-btn
                    outlined
                    width="150px"
                    class="common-cancel-btn"
                    @click="searchAgreement()"
                >
                  検索
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-data-table
                  :headers="headers"
                  :items="list"
                  :items-per-page=perPage
                  :server-items-length="total"
                  :page="currentPage"
                  hide-default-footer
                  no-data-text=""
                  class="no-shadow"
              >
                <template v-slot:item.actions="{ item }">
                  <v-icon
                      small
                      class="common-edit-icon mr-2"
                      @click="editAgreement(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <Pagination v-if="total > perPage" :currentPage=currentPage :lastPage=lastPage />

        </v-card-text>
      </v-card>
    </v-col>
  </v-container>
</template>


<script>
import axios from "axios";
import {UNPROCESSABLE_ENTITY} from "/src/util";
import Pagination from '/src/views/components/utility/Pagination'

export default {
  components: {
    Pagination
  },
  data: () => ({
    searchCompanyCode: "" ,
    searchStoreCode: "",
    headers: [
      {text: '企業コード', value: 'company_code', sortable: false},
      {text: '企業名', value: 'company_name', sortable: false},
      {text: '店舗コード', value: 'store_code', sortable: false},
      {text: '店舗名', value: 'store_name', sortable: false},
      {text: 'WEBレポート', value: 'agreement_web_report_status', sortable: false},
      {text: '需要予測', value: 'agreement_demand_report_status', sortable: false},
      {text: '', value: 'actions', sortable: false},
    ],
    list: [],
    errors: [],
    dialog: false,
    currentPage: 1,
    lastPage: 1,
    perPage: 15,
    total: 0,
  }),
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.searchCompanyCode = this.$store.getters['auth/company_code']
      if (Object.keys(this.$route.query).length !== 0) {
        // URLパラメータを画面にセット
        if (this.$route.query.companyCode !== undefined) {
          this.searchCompanyCode = this.$route.query.companyCode
        }

        if (this.$route.query.storeCode !== undefined) {
          this.searchStoreCode = this.$route.query.storeCode
        }

        if (this.searchCompanyCode.length !== 0) {
          this.fetch()
        }
      }
    },
    searchAgreement() {
      // 1ページ目だとwatchが発動しないため更新
      if (this.$route.query.page === undefined || parseInt(this.$route.query.page) === 1) {
        this.fetch()
      }

      // URL変更
      this.$router.push({
        query: {
          companyCode: this.searchCompanyCode,
          storeCode: this.searchStoreCode,
          page: 1,
        }
      }).catch(()=>{})
    },
    async fetch() {
      // 契約状況一覧を取得
      let url = `/setting/agreement?company_code=${this.searchCompanyCode}&store_code=${this.searchStoreCode}&page=${this.page}`
      const response = await axios.get(url)
      const result = response.data?.result || 0

      this.list = []
      this.errors = []
      if (response.status === UNPROCESSABLE_ENTITY) {
        this.errors = response.data.errors || []
      } else if (result === true) {
        const tmp = response.data.data
        this.list = tmp.data
        this.currentPage = tmp.current_page
        this.lastPage = tmp.last_page
        this.perPage = parseInt(tmp.per_page)
        this.total = tmp.total
      }
    },
    editAgreement(agreementId) {
      // 編集画面に遷移
      this.$router.push({
        name: 'setting.agreement.edit',
        params: {id: agreementId, companyCode: this.searchCompanyCode, storeCode: this.searchStoreCode, page: this.page}
      })
    }
  },
  watch: {
    page: {
      handler() {
        this.fetch()
      },
      immediate: false
    }
  },
  props: {
    page: {
      type: Number,
      required: false,
      default: 1
    }
  },
}
</script>